import { render, staticRenderFns } from "./ParticaUIBase.vue?vue&type=template&id=53353a68&"
import script from "./ParticaUIBase.vue?vue&type=script&lang=ts&"
export * from "./ParticaUIBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports